const base =
  'after:absolute after:bottom-0 after:content-[""] after:left-0 after:right-0 after:top-0 after:z-1';

export const lightLoadingOverlay = `${base} after:backdrop-blur-sm`;

export const loadingOverlay = `${base} after:backdrop-blur`;
